import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnSearchBtn from "@shared/components/SnSearchBtn";
import { getInitPopUpData } from "@shared/utils/CommonUtils";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_SAL_SAO_REG_001_POP_001 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    const { userInfo } = global();

    const searchRef = useRef<any>(null);
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
      grid2: React.createRef(),
    });

    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns, setColums] = useState<any>({
      grid1: [],
      grid2: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
      grid2: [],
    });

    const [doubleData, setDoubleData] = useState<any[]>();
    const [popupParent, setPopupParent] = useState<any>(null);

    useImperativeHandle(ref, () => ({
      getSelectedRow: () => [
        gridRefs.current["grid1"].current.getSelectedRows() || [],
        gridRefs.current["grid2"].current.getFilteredData() || [],
      ],
    }));

    useEffect(() => {
      if (modalRef?.current) {
        setPopupParent(modalRef.current.getPopupParent());
      }
    }, [modalRef?.current]);

    useEffect(() => {
      if (doubleData) {
        modalRef.current?.handleConfirm(true);
      }
    }, [doubleData]);

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData("SN_SAL_SAO_REG_001_POP_001");
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData);
          setFormData(mergedData);
          setColums({
            grid1: rtn.grid.grid1,
            grid2: rtn.grid.grid2,
          });
          gridRefs.current["grid1"].current.selectAndFocusRow(0);
        } catch (error) {}
      };
      fetchform();
    }, [userInfo]);

    const onSearch = async () => {
      const fetchdatasource = async () => {
        try {
          const params = {
            id: "sn_sal_sao_reg_001_pop_01",
            params: searchRef.current.getFormdata(),
          };

          const data: any = await fnGetDataSet(params);
          setDataSources({
            grid1: data[0] || [],
            grid2: data[1] || [],
          });
          gridRefs.current["grid1"].current.resetUpdate();
          gridRefs.current["grid2"].current.resetUpdate();
        } catch (error) {}
      };
      await fetchdatasource();
    };

    const onFocusedRowChanged = (event: any) => {
      const selectedRow = event;
      if (selectedRow) {
        const no_est = selectedRow.no_est;
        gridRefs.current["grid2"].current.applyFilters({ no_est: no_est });
        gridRefs.current["grid2"].current.selectAndFocusRow(0, true);
      } else {
        return;
      }
    };

    const onRowDoubleClicked = (e: any) => {
      const returnData: any[] =
        gridRefs.current["grid2"].current.getFilteredData();
      const exists = returnData.some(
        (data) =>
          data.no_est === e.data.no_est &&
          data.no_hst === e.data.no_hst &&
          data.no_line === data.no_line
      );
      if (!exists) returnData.push(e.data);
      setDoubleData(returnData);
    };

    const onRowDataReady = () => {
      gridRefs.current["grid1"].current.selectAndFocusRow(0, false);
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onFocusedRowChanged: onFocusedRowChanged,
            onRowDoubleClicked: onRowDoubleClicked,
          },
        },
        grid2: {
          columns: columns.grid2,
          dataSource: dataSources.grid2,
          events: {
            onRowDoubleClicked: onRowDoubleClicked,
            onRowDataReady: onRowDataReady,
          },
        },
      }),
      [columns, dataSources]
    );

    return (
      <div className="h-full flex flex-col">
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div className="mb-2" style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>

        <div className="flex-1 flex flex-col gap-2 min-h-00">
          <div className="flex-1 min-h-0">
            <SnGrid
              ref={gridRefs.current["grid1"]}
              columnConfig={grids.grid1.columns}
              rowData={grids.grid1.dataSource}
              etcProps={{
                rowSelection: "single",
                isEditable: false,
                ischeckboxSelection: false,
                popupParent: popupParent,
              }}
              events={grids.grid1.events}
            />
          </div>
          <div className="flex-1 min-h-10">
            <SnGrid
              ref={gridRefs.current["grid2"]}
              columnConfig={grids.grid2.columns}
              rowData={grids.grid2.dataSource}
              etcProps={{
                rowSelection: "multiple",
                isEditable: false,
                ischeckboxSelection: false,
                popupParent: popupParent,
                // grid2는 조회 후 포커스를 뺏지 않음 (포커스는 grid1 유지)
                suppressInitialCellFocus: true,
              }}
              events={grids.grid2.events}
            />
          </div>
        </div>
      </div>
    );
  }
);

export default SN_SAL_SAO_REG_001_POP_001;
